module.exports = __webpack_public_path__ + "static/media/error.df2bee4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/error.jpg
// module id = 1072
// module chunks = 0